import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useCallback, useEffect } from 'react';

/**
 * A hook to track whether an element is currently visible on screen
 * @param {object} options Additional options for controlling visibility
 * @returns {[]} An array in the format: [ref, visible]
 * @returns {object} `ref` A ref to pass to the element to track
 * @returns {boolean} `visible` Whether the element is currently visible
 */

var useElementVisibility = function useElementVisibility() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      root = _ref.root,
      rootMargin = _ref.rootMargin,
      threshold = _ref.threshold;

  var isMounted = useRef(false);
  var initialRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      stateRef = _useState2[0],
      setStateRef = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var setRef = useCallback(function (ref) {
    // if not mounted yet store as a ref to avoid extra state update/render
    if (isMounted.current) {
      setStateRef(ref);
    } else {
      initialRef.current = ref;
    }
  }, []);
  useEffect(function () {
    isMounted.current = true;
    var ref = stateRef !== null && stateRef !== void 0 ? stateRef : initialRef.current;
    if (!ref) return;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          entry = _ref3[0];

      return setVisible(entry.isIntersecting);
    }, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold
    });
    observer.observe(ref);
    return function () {
      observer.disconnect();
    };
  }, [stateRef, root, rootMargin, threshold]);
  return [setRef, visible];
};

var useElementVisibility$1 = useElementVisibility;

export { useElementVisibility$1 as default };
